export function shipperIsTransport(shipper) {
  if (!shipper || typeof shipper !== "object") return false;
  const value = shipper.isTransport;
  return (
    value === true ||
    value === 1 ||
    String(value).toLowerCase() === "true"
  );
}

export function isUserTransportadora(user, shipper) {
  return (
    shipperIsTransport(shipper) ||
    user?.Transportadora === true ||
    user?.transportadora === true
  );
}

/**
 * Escopo por embarcador/transportadora (uidShipper, affiliates, viewAll).
 * Mesma regra usada em GET /freight/v2 e listagens por embarcador.
 */
export function applyShipperScopeParams(params, user, shipper) {
  const carrierUid = String(user?.uidShipper ?? "").trim();
  const isTransportadora = isUserTransportadora(user, shipper);

  if (isTransportadora && carrierUid) {
    params.uidShipper = carrierUid;
    params.isTransportadora = true;
    return;
  }

  const isViewAll = user?.viewALL === true;
  if (!isViewAll) {
    if (user?.uidShipper) {
      params.uidShipper = user.uidShipper;
      if (user?.uid) params.idUser = user.uid;
    }
    if (
      Array.isArray(user?.uidShipperAffiliates) &&
      user.uidShipperAffiliates.length
    ) {
      params.affiliates = user.uidShipperAffiliates.join(",");
    }
  }
  if (typeof user?.viewALL === "boolean") {
    params.viewAll = String(user.viewALL);
  }
}

/** UIDs de embarcador permitidos para o usuário logado (null = viewALL). */
export function getShipperScopeUids(user) {
  if (!user || user.viewALL === true) {
    return null;
  }

  const affiliateUids = Array.isArray(user.uidShipperAffiliates)
    ? user.uidShipperAffiliates
    : [];
  const primaryUid = user.uidShipper ? [user.uidShipper] : [];
  return Array.from(new Set([...affiliateUids, ...primaryUid])).filter(Boolean);
}

export function recordMatchesShipperScope(record, user) {
  const allowedUids = getShipperScopeUids(user);
  if (allowedUids === null) {
    return true;
  }
  if (!allowedUids.length) {
    return false;
  }
  return allowedUids.includes(String(record?.uidShipper ?? "").trim());
}
